import { render, staticRenderFns } from "./Kategori.vue?vue&type=template&id=244a7dc1&scoped=true&"
import script from "./Kategori.vue?vue&type=script&lang=js&"
export * from "./Kategori.vue?vue&type=script&lang=js&"
import style0 from "./Kategori.vue?vue&type=style&index=0&id=244a7dc1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a7dc1",
  null
  
)

export default component.exports